// @flow

import type { ShiftPatternsState } from "./types";

export const initialState: ShiftPatternsState = {
  error: null,
  list: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
};

export default initialState;
